import React, { Component } from 'react'
import Table from './Table'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    return (
      <HeaderView title="案例优化">
        <Table />
      </HeaderView>
    )
  }
}
